module.exports = __webpack_public_path__ + "img/medscape_plugin.656901e0.png";